import { createFileRoute } from "@tanstack/react-router";

import { OnboardingJobDetailPage } from "@/pages/Sales";

export const Route = createFileRoute("/app/sales/onboarding-jobs/$job_id")({
  component: OnboardingJobDetailRoute,
});

function OnboardingJobDetailRoute() {
  const { job_id } = Route.useParams();
  return <OnboardingJobDetailPage jobId={job_id} />;
}
